import { render, staticRenderFns } from "./topLeft.vue?vue&type=template&id=4a8e9372&"
import script from "./topLeft.vue?vue&type=script&lang=js&"
export * from "./topLeft.vue?vue&type=script&lang=js&"
import style0 from "./topLeft.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports